export interface FaqsItem {
  question: string;
  answer: string;
}

export interface SocialMediaItem {
  name: string;
  link: string;
  isHidden: boolean;
}

export interface HelpCenters {
  cxEmail: string;
  website: string;
  faqs: FaqsItem[];
  socialMedia: SocialMediaItem[];
}

export interface HelpCenterState {
  helpCenters: HelpCenters;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

export interface UpdateHelpCenters {
  cxEmail?: string;
  website?: string;
  faqs?: FaqsItem[];
  socialMedia?: SocialMediaItem[];
  updatedBy: string;
}

export enum HelpCenterKeys {
  cxEmail = "cxEmail",
  website = "website",
  faqs = "faqs",
  socialMedia = "socialMedia",
}
